import { useContext } from 'react'
import { RemoteDataContext } from '../context'

export function useRemoteData() {
  return useContext(RemoteDataContext)
}
